module.exports = __webpack_public_path__ + "fonts/Arimo-400-greek-ext3.7105dcd.woff2";